// ============================================
// tk-purchase-limit.js
// 購入制限チェック（cart.js を触らない方式）
// タグ「_購入制限N」または「_購入制限N_日付」
// ============================================

// 商品タグから購入上限を取得（共通関数）
async function getPurchaseLimit(productHandle) {
  try {
    const res = await fetch('/products/' + productHandle + '.js');
    const product = await res.json();
    const tags = product.tags || [];
    for (const tag of tags) {
      if (tag.startsWith('_購入制限')) {
        const match = tag.match(/^_購入制限(\d+)/);
        if (match) return parseInt(match[1], 10);
      }
    }
  } catch (e) {
    console.error('購入制限タグ取得エラー:', e);
  }
  return null;
}

// ① カートページ・ドロワーの数量変更制限
(function () {
  function waitForCartItems(callback) {
    if (customElements.get('cart-items')) {
      callback();
    } else {
      setTimeout(() => waitForCartItems(callback), 100);
    }
  }

  waitForCartItems(function () {
    const OriginalCartItems = customElements.get('cart-items');
    const originalUpdateQuantity = OriginalCartItems.prototype.updateQuantity;

    OriginalCartItems.prototype.updateQuantity = async function (line, quantity, name) {
      const newQty = parseInt(quantity, 10);

      if (newQty > 0) {
        try {
          const cartRes = await fetch('/cart.js');
          const cartData = await cartRes.json();
          const targetItem = cartData.items[parseInt(line, 10) - 1];

          if (targetItem) {
            const limit = await getPurchaseLimit(targetItem.handle);

            if (limit !== null && newQty > limit) {
              const qEl =
                document.getElementById('Quantity-' + line) ||
                document.getElementById('Drawer-quantity-' + line);
              if (qEl) qEl.value = limit;

              this.updateLiveRegions(
                line,
                'この商品はお一人様' + limit + '個までとなっております。'
              );
              this.disableLoading(line);
              quantity = limit;
            }
          }
        } catch (e) {
          console.error('カート取得エラー:', e);
        }
      }

      return originalUpdateQuantity.call(this, line, quantity, name);
    };
  });
})();

// ② 商品ページの数量入力制限＋メッセージ表示
document.addEventListener('DOMContentLoaded', async function () {
  // URLから商品ハンドルを取得
  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!match) return;

  const handle = match[1];
  const limit = await getPurchaseLimit(handle);
  if (limit === null) return;

  function applyLimit() {
    // 数量入力欄に上限をセット
    const qtyInputs = document.querySelectorAll('input[name="quantity"]');
    qtyInputs.forEach(function (input) {
      input.setAttribute('max', limit);
      if (parseInt(input.value, 10) > limit) {
        input.value = limit;
      }
      input.addEventListener('change', function () {
        if (parseInt(this.value, 10) > limit) {
          this.value = limit;
          alert('この商品はお一人様' + limit + '個までとなっております。');
        }
      });
    });

    // ＋ボタンを監視
    const plusBtns = document.querySelectorAll('.quantity__button[name="+"]');
    plusBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(function () {
          const input = document.querySelector('input[name="quantity"]');
          if (input && parseInt(input.value, 10) > limit) {
            input.value = limit;
            alert('この商品はお一人様' + limit + '個までとなっております。');
          }
        }, 50);
      });
    });

    // 制限メッセージを「カートに追加」ボタンの下に表示
    const addBtn = document.querySelector('.product-form__submit');
    if (addBtn && !document.getElementById('tk-limit-msg')) {
      const msg = document.createElement('p');
      msg.id = 'tk-limit-msg';
      msg.textContent = 'こちらの商品はお一人様' + limit + '個までとさせていただきます。';
      msg.style.cssText = 'color:#c00; font-size:0.9em; margin-top:8px;';
      addBtn.parentNode.insertBefore(msg, addBtn.nextSibling);
    }
  }

  applyLimit();
});


// _購入制限 タグを商品ページから非表示にする
document.querySelectorAll('.product__tags .tag, [class*="tag"]').forEach(function(el) {
  if (el.textContent.trim().startsWith('_購入制限')) {
    el.style.display = 'none';
  }
});